import { Text } from "@merge-api/merge-javascript-shared";
import { AlertTriangle } from "lucide-react";

const NotFoundBanner = ({ label, uuid }: { label: string; uuid: string }) => (
  <div className="flex items-center gap-3 px-4 py-3 rounded-lg border border-orange-200 bg-orange-50 mt-4">
    <AlertTriangle size={16} className="text-orange-500 flex-none" />
    <div className="min-w-0">
      <Text variant="sm" className="font-medium text-orange-800">
        {label} not found
      </Text>{" "}
      <Text variant="caption" className="text-orange-600 font-mono break-all">
        {uuid}
      </Text>
    </div>
  </div>
);

export default NotFoundBanner;
